import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcSnsNaverblog(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "34",
    height: "16",
    fill: "none",
    viewBox: "0 0 34 16",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#8B8D92",
    fillRule: "evenodd",
    d: "M9.457 2.648V0c4.135.167 3.904 3.766 3.897 3.875v7.588h-2.629v-7.51c0-1.022-1.268-1.305-1.268-1.305m-4.313.89s-1.826-.019-2.459 1.059V.36S.165.393 0 .366v11.079h2.685v-.644s.805.946 2.232.946c0 0 3.688-.103 3.707-3.67.001 0 .497-4.169-3.48-4.539m-.826 5.744a1.545 1.545 0 1 1 0-3.092 1.545 1.545 0 0 1 0 3.092M15.18 7.695c0-2.242 1.972-4.058 4.406-4.058 2.435 0 4.408 1.816 4.408 4.058s-1.972 4.057-4.408 4.057c-2.433 0-4.406-1.817-4.406-4.057m2.742-.001a1.665 1.665 0 1 0 3.33-.001 1.665 1.665 0 0 0-3.33.001m13.402-3.135c-.871-1.173-2.289-1.02-2.289-1.02-3.594.265-3.67 3.574-3.67 3.574v1.211c0 3.192 3.273 3.428 3.273 3.428 2.307 0 2.627-1.026 2.627-1.026.02 2.535-1.625 2.384-1.625 2.384h-.719v2.497h1.191c3.916 0 3.877-3.854 3.877-3.854V3.747h-2.666zm-1.516 4.762a1.628 1.628 0 1 1 .006-3.256 1.628 1.628 0 0 1-.006 3.256",
    clipRule: "evenodd"
  }));
}
var IcSnsNaverblog = createNolIcon(/*#__PURE__*/forwardRef(SvgIcSnsNaverblog));

export { IcSnsNaverblog as I };
